import React from 'react';
import { DisputeExportButton } from '@pay-bill/components';
import { Colors, FontSize } from '@common/tokens';

export const DisputeBulkActionFooter = ({
  disputeIds,
  onFinish,
}: {
  disputeIds: string[];
  onFinish: () => void;
}) => {
  return (
    <div className="bulk-action-content">
      <footer className="bulk-action-footer">
        <div className="footer-element">
          {disputeIds.length} items selected.
        </div>
        <div className="footer-element">
          <DisputeExportButton disputeIds={disputeIds} onFinish={onFinish} />
        </div>
      </footer>
      <style jsx>{`
        .bulk-action-content {
          margin-top: 32px;
        }
        .footer-element {
          font-size: ${FontSize.md};
          margin-right: 16px;
        }
        .bulk-action-footer {
          padding: 16px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          background-color: ${Colors.white};
          position: fixed;
          bottom: 0;
          left: 80px;
          width: calc(100% - 80px);
        }
      `}</style>
    </div>
  );
};
